export const actionTypes = {
  REQUEST_START: 'PROFILE.PARTICIPATION_IN_QES_ORGANIZATIONS.REQUEST_START',
  REQUEST_SUCCESS: 'PROFILE.PARTICIPATION_IN_QES_ORGANIZATIONS.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'PROFILE.PARTICIPATION_IN_QES_ORGANIZATIONS.REQUEST_FAILURE',
};

export function getParticipation() {
  return {
    type: actionTypes.REQUEST_START,
  };
}

export function getParticipationSuccess(payload) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload,
  };
}

export function getParticipationFailure(payload) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload,
  };
}
